<template>
  <Menu
    as="div"
    class="w-full md:relative"
  >
    <div>
      <MenuButton
        class="w-full bg-gray-100 flex items-center justify-between rounded-full border border-gray-400 text-blue-600 text-xs md:text-sm font-medium px-3.5 py-1"
      >
        <span class="truncate">{{ selectedLocation.name }}</span>
        <ChevronDownIcon
          class="text-gray-500 h-4 w-4 shrink-0"
          aria-hidden="true"
        />
      </MenuButton>
    </div>

    <MenuItems
      class="overflow-hidden origin-top-left absolute left-4 right-4 rounded-md shadow-lg bg-gray-100 z-20 md:w-80 border border-gray-400 mt-1 divide-y divide-gray-400"
    >
      <MenuItem
        v-for="location in locations"
        :key="location.id"
      >
        <button
          type="button"
          @click="emit('selectLocation', location)"
          class="hover:bg-blue-600 hover:text-gray-100 px-4 py-3 text-sm w-full flex gap-x-1 items-center"
          :class="{
            'bg-blue-600 text-gray-100': location.id === selectedLocation.id,
            'text-gray-700': location.id !== selectedLocation.id
          }"
        >
          <CheckIcon
            v-if="location.id === selectedLocation.id"
            class="h-4 w-4"
          />
          <span class="truncate">{{ location.name }}</span>
        </button>
      </MenuItem>
    </MenuItems>
  </Menu>
</template>

<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import { computed } from 'vue'
import { CheckIcon } from '@heroicons-2/vue/24/solid'

const emit = defineEmits(['selectLocation'])

const props = defineProps({
  locations: {
    type: Array,
    required: true
  },
  selectedLocationId: {
    type: Number,
    required: true
  }
})

const selectedLocation = computed(() => {
  return props.locations.find((location) => location.id === props.selectedLocationId)
})
</script>
